// Canvas sizes are the on-page size in px; exports are 2x so prints stay sharp.
export const PRESETS = [
  { key: "a4p", label: "A4 Portrait", w: 794, h: 1123 },
  { key: "a4l", label: "A4 Landscape", w: 1123, h: 794 },
  { key: "banner", label: "Water Test Footer Banner", w: 786, h: 200 },
  { key: "offer", label: "Special Offer Image", w: 260, h: 190 },
  { key: "card", label: "Page 2 Product Photo", w: 200, h: 200 },
  { key: "green", label: "Green Pool Photo (Page 3)", w: 786, h: 190 },
  { key: "email", label: "Email Header", w: 600, h: 200 },
  { key: "email_banner", label: "Email Banner / Feature", w: 600, h: 300 },
  { key: "newsletter", label: "Email Newsletter Page", w: 600, h: 1500 },
  { key: "custom", label: "Custom size…", w: 800, h: 600 },
];
export const EXPORT_SCALE = 2;

// Water Test Layout image slots ("Send to Report")
export const SLOTS = (layout) => [
  ["promo1", "Page 1 – Special Offer image", (pk) => `promos.${pk}.image`, "offer"],
  ["banner1", "Page 1 – Footer banner", (pk) => `promos.${pk}.banner`, "banner"],
  ["promo2", "Page 2 – Special Offer image", () => "page2.promo.image", "offer"],
  ["banner2", "Page 2 – Footer banner", () => "page2.banner", "banner"],
  ...((layout?.page2?.cards || []).map((c, i) => [`card${i}`, `Page 2 – Card ${i + 1} photo (${c.title})`, () => `page2.cards.${i}.image`, "card"])),
  ["green", "Page 3 – Green pool photo", () => "page3.image", "green"],
];

export const FONTS = ["Arial", "Arial Black", "Impact", "Verdana", "Tahoma", "Georgia", "Times New Roman", "Courier New",
  "Montserrat", "Oswald", "Bebas Neue", "Anton", "Poppins", "Lobster", "Pacifico", "Permanent Marker"];
export const GOOGLE_FONTS_URL = "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&family=Oswald:wght@400;700&family=Bebas+Neue&family=Anton&family=Poppins:wght@400;700;900&family=Lobster&family=Pacifico&family=Permanent+Marker&display=swap";

// Brand Kit (loaded by the studio page): brand colours/fonts are shown first everywhere.
export const BRAND = { colors: [], fonts: [], logos: [] };
export const SWATCHES = ["#ffffff", "#000000", "#222736", "#1f4e86", "#21a6ec", "#8bc34a", "#0b6623", "#7b3fc4", "#7a1f7a", "#e3171b", "#f4b400", "#ff7f27", "#fbf7a6", "#9e9e9e"];
